import { render, staticRenderFns } from "./CultiveByColor.vue?vue&type=template&id=58273b32"
import script from "./CultiveByColor.vue?vue&type=script&lang=js"
export * from "./CultiveByColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports